<script setup>
import Button from 'dashboard/components-next/button/Button.vue';
import { useGgFollowup } from 'dashboard/composables/useGgFollowup';

const props = defineProps({
  conversationId: { type: Number, required: true },
  menu: { type: Boolean, default: false },
});
const emit = defineEmits(['selected']);
const { enabled, open } = useGgFollowup('support');
const launch = () => {
  open(props.conversationId);
  emit('selected');
};
</script>

<template>
  <Button
    v-if="enabled"
    type="button"
    :label="$t('GG_SUPPORT.BUTTON')"
    :title="$t('GG_SUPPORT.BUTTON')"
    :class="menu ? 'w-full justify-start' : 'shrink-0'"
    color="slate"
    :variant="menu ? 'ghost' : 'faded'"
    size="sm"
    @click.stop="launch"
  />
</template>
